/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from '../runtime';
/**
 * 
 * @export
 * @interface HchbExternalEhrDocument
 */
export interface HchbExternalEhrDocument {
    /**
     * 
     */
    id?: string;
    /**
     * 
     */
    external_document_id?: string;
    /**
     * 
     */
    created_at?: Date;
    /**
     * 
     */
    error_message?: string;
}

/**
 * Check if a given object implements the HchbExternalEhrDocument interface.
 */
export function instanceOfHchbExternalEhrDocument(value: object): value is HchbExternalEhrDocument {
    return true;
}

export function HchbExternalEhrDocumentFromJSON(json: any): HchbExternalEhrDocument {
    return HchbExternalEhrDocumentFromJSONTyped(json, false);
}

export function HchbExternalEhrDocumentFromJSONTyped(json: any, ignoreDiscriminator: boolean): HchbExternalEhrDocument {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'external_document_id': json['external_document_id'] == null ? undefined : json['external_document_id'],
        'created_at': json['created_at'] == null ? undefined : (parseDateTime(json['created_at'])),
        'error_message': json['error_message'] == null ? undefined : json['error_message'],
    };
}

export function HchbExternalEhrDocumentToJSON(json: any): HchbExternalEhrDocument {
    return HchbExternalEhrDocumentToJSONTyped(json, false);
}

export function HchbExternalEhrDocumentToJSONTyped(value?: HchbExternalEhrDocument | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'external_document_id': value['external_document_id'],
        'created_at': value['created_at'] == null ? value['created_at'] : serializeDateTime(value['created_at']),
        'error_message': value['error_message'],
    };
}

